import React, { Component } from 'react';
import { VehicleCategoryFilter } from './VehicleCategoryFilter';
import { BrandFilter } from './BrandFilter';
import { ModelFilter } from './ModelFilter';
import { DiffResult } from '../Grid/DiffResult';
import { Button, Collapse } from 'react-bootstrap';
import queryString from 'query-string';

export class AnnualDiff extends Component {
    constructor(props) {
        super(props);

        const parameters = queryString.parse(this.props.location.search);

        this.state = {
            showDetailedView: parameters.detailedView === '1' || parameters.detailedView === 'true',
            showFilter: false,
            oldYear: null,
            newYear: null,
            annualDiffData: null,
            vehicleCategoryOptions: [],
            brandOptions: [],
            modelOptions: [],
            selectedVehicleCategory: null,
            selectedBrand: null,
            selectedModel: null,
            loadingVehicleCategories: true,
            loadingBrands: true,
            loadingModels: true
        };
    }

    componentDidMount() {
        this.getAnnualDiffDefinition();
        this.getVehicleCategoryOptions(true);
    }

    handleChangeVehicleCategory = selectedVehicleCategory => {
        this.setState({ selectedVehicleCategory }, () => { this.getBrandOptions(); });
    }

    handleChangeBrand = selectedBrand => {
        this.setState({ selectedBrand }, () => { this.getModelOptions(); });
    }

    handleChangeModel = selectedModel => {
        this.setState({ selectedModel }, () => { this.getAnnualDiff(); });
    }

    getSelectedVehicleCategoryValue = () => {
        return this.state.selectedVehicleCategory
            ? this.state.selectedVehicleCategory.value
            : '';
    }

    getSelectedBrandValue = () => {
        return this.state.selectedBrand
            ? this.state.selectedBrand.value
            : '';
    }

    getSelectedModelValue = () => {
        return this.state.selectedModel
            ? this.state.selectedModel.value
            : '';
    }

    getSelectedVehicleName = () => {
        return this.state.selectedModel
            ? `${this.state.selectedBrand.label} ${this.state.selectedModel.label}`
            : (this.state.selectedBrand
                ? this.state.selectedBrand.label
                : '');
    }

    async getVehicleCategoryOptions(firstLoad) {
        fetch('api/FilterCriteria/VehicleCategory')
            .then(response => { return response.json(); })
            .then(data => {
                this.setState({
                    vehicleCategoryOptions: data,
                    selectedVehicleCategory: data.find(x => x.value === this.getSelectedVehicleCategoryValue()) || data[0],
                    loadingVehicleCategories: false
                }, () => this.getBrandOptions(firstLoad))
            });
    }

    async getBrandOptions(firstLoad) {
        fetch(`api/FilterCriteria/Brand?vehicleCategoryId=${this.getSelectedVehicleCategoryValue()}`)
            .then(response => { return response.json(); })
            .then(data => {
                this.setState({
                    brandOptions: data,
                    selectedBrand: data.find(x => x.value === this.getSelectedBrandValue()) || data[0],
                    loadingBrands: false
                }, () => this.getModelOptions(firstLoad))
            });
    }

    async getModelOptions(firstLoad) {
        fetch(`api/FilterCriteria/Model?vehicleCategoryId=${this.getSelectedVehicleCategoryValue()}&brandId=${this.getSelectedBrandValue()}`)
            .then(response => { return response.json(); })
            .then(data => {
                this.setState({
                    modelOptions: data,
                    selectedModel: firstLoad || this.state.selectedModel ? (data.find(x => x.value === this.getSelectedModelValue()) || data[0]) : null,
                    loadingModels: false
                }, () => this.getAnnualDiff())
            });
    }

    async getAnnualDiffDefinition() {
        fetch('api/AnnualDiff/Definition')
            .then(response => { return response.json(); })
            .then(data => this.setState({
                oldYear: data.oldYear,
                newYear: data.newYear
            }));
    }

    async getAnnualDiff() {
        fetch(`api/AnnualDiff/DiffData?vehicleCategoryId=${this.getSelectedVehicleCategoryValue()}&brandId=${this.getSelectedBrandValue()}&modelId=${this.getSelectedModelValue()}`)
            .then(response => { return response.json(); })
            .then(data => this.setState({
                annualDiffData: data
            }));
    }

    render() {
        return (
            <>
                <Collapse in={this.state.showFilter}>
                    <div className="filter-container">
                        <VehicleCategoryFilter
                            options={this.state.vehicleCategoryOptions}
                            value={this.state.selectedVehicleCategory}
                            loading={this.state.loadingVehicleCategories}
                            onChange={this.handleChangeVehicleCategory} />
                        <BrandFilter
                            options={this.state.brandOptions}
                            value={this.state.selectedBrand}
                            loading={this.state.loadingBrands}
                            onChange={this.handleChangeBrand} />
                        <ModelFilter
                            options={this.state.modelOptions}
                            value={this.state.selectedModel}
                            loading={this.state.loadingModels}
                            onChange={this.handleChangeModel} />
                    </div>
                </Collapse>
                <div className="filter-expander">
                    <Button size="sm" onClick={() => this.setState({showFilter: !this.state.showFilter})}>
                        <span>&nbsp;</span>Filter
                    </Button>
                </div>
                <div className="grid-wrapper compact">
                    <DiffResult
                        rowData={this.state.annualDiffData}
                        oldYear={this.state.oldYear}
                        newYear={this.state.newYear}
                        showDetailedView={this.state.showDetailedView}
                        variantName={this.getSelectedVehicleName()} />
                </div>
            </>
        );
    }
}
